import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {UserGroupCollection} from "../../../collections/UserGroups";
import {StatusNotificationCollection} from "../../../collections/StatusNotifications";
import {DashboardNotificationCollection} from "../../../collections/DashboardNotifications";
import {BaseList, TableProperties} from "../../_BaseList";
import {User} from "../../../models/User";
import {DashboardCollection} from "../../../collections/Dashboards";
import {InstallCollection} from "../../../collections/Installs";
import {PermissionCollection} from "../../../collections/Permissions";
import {DashboardWidgetCollection} from "../../../collections/DashboardWidgets";
import {BaseDetailAccountView, BaseDetailAccountViewOptions} from "../_BaseAccountViews";
import {TimezoneCollection} from "../../../collections/Timezones";
import {Intercom} from "../../../common/intercom";
import {checkPasswordPolicy, PasswordPolicyItem} from "../../../common/passwords";


export interface UserDetailViewOptions extends BaseDetailAccountViewOptions {
    currentUserProfile: User;
}

abstract class BaseUserDetailView extends BaseDetailAccountView {
    options: UserDetailViewOptions;

    constructor(options: UserDetailViewOptions) {
        super(options);
    }
}

export class UserProfileView extends BaseUserDetailView {

    protected profileTemplate = _.template(require('templates/account/user/profile.html'));

    constructor(options: UserDetailViewOptions) {
        super(<any> _.extend(options, {
            events: {
                'click .profile-form-change-password-trigger': 'handleChangePasswordClicked',
                'submit .profile-form': 'handleFormSubmit',
                'input .profile-form-password': 'handlePasswordInput',
                'input .profile-form-password-2': 'handlePasswordInput',
            }
        }));
    }

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/users/' +
            this.options.currentUserProfile.get('id') + '/profile';

        this.$el.html(this.template({
            panelTitle: {text: this.options.currentUserProfile.get('name'), url: this.options.isOverview ? url : null},
            panelClass: 'profile',
            panelWidth: '',
            addButton: null,
            search: null,
            collectionLoaded: this.collectionLoaded,
            footer: null
        }));
        return this;
    }

    show() {
        this.collectionLoaded = true;
        this.render();
        this.showProfile();
    }

    showProfile() {
        var profileIsCurrentUser = this.options.currentUser.get('id') === this.options.currentUserProfile.get('id');
        var userIsOrgAdmin = this.options.currentUser.isSensewareAdmin();

        this.options.userGroupCollection.each((group) => {
            if (_.has(this.options.currentUser.get('usergroups'), String(group.get('id'))) && group.get('is_admin')) {
                userIsOrgAdmin = true;
            }
        }, this);

        this.$('.profile .panel-body > .row').empty().append(this.profileTemplate({
            user: this.options.currentUserProfile,
            timezones: new TimezoneCollection(),
            userIsOrgAdmin: userIsOrgAdmin,
            profileIsCurrentUser: profileIsCurrentUser,
            editable: userIsOrgAdmin || profileIsCurrentUser,
            PasswordPolicyItem: PasswordPolicyItem
        }));
    }

    private handleChangePasswordClicked() {
        this.$('.profile-form-password-section').removeClass('hidden');
        this.$('.profile-form-change-password-section').addClass('hidden');
    }

    private handlePasswordInput() {
        var password = this.$('.profile-form-password').val().toString();
        var policyCheck = checkPasswordPolicy(password);
        _.each(policyCheck.pass, (p) => {
            this.$(`.password-policy-item[data-item="${p}"]`).removeClass('fa-times text-danger-bright');
            this.$(`.password-policy-item[data-item="${p}"]`).addClass('fa-check text-success-bright');
        });
        _.each(policyCheck.fail, (p) => {
            this.$(`.password-policy-item[data-item="${p}"]`).addClass('fa-times text-danger-bright');
            this.$(`.password-policy-item[data-item="${p}"]`).removeClass('fa-check text-success-bright');
        });

        var passwordConfirm = this.$('.profile-form-password-2').val().toString();
        this.$(`.password-policy-match-info`).removeClass('hidden');
        this.$(`.password-policy-match`).toggleClass('fa-times text-danger-bright', password != passwordConfirm);
        this.$(`.password-policy-match`).toggleClass('fa-check text-success-bright', password == passwordConfirm);

        this.$(`button`).prop('disabled', policyCheck.fail.length || password != passwordConfirm);
    }

    private setErrors(errors?) {
        var selector = this.$('.profile-form-errors');
        if (!errors) return selector.addClass('hidden');

        selector.find('ul').html(_.map(errors, function (e) {
            return '<li>' + e + '</li>'
        }).join(''));
        selector.removeClass('hidden');
    }

    private handleFormSubmit(e) {
        e.preventDefault();
        this.setErrors();

        var name = (<string> this.$('.profile-form-name').val()).trim();
        var timezone = (<string> this.$('.profile-form-timezone').val());
        var company = (<string> this.$('.profile-form-company').val()).trim();
        var role = (<string> this.$('.profile-form-role').val()).trim();
        var phone = (<string> this.$('.profile-form-phone').val()).trim();
        var phoneValidator = /^[().+\d -]{7,15}$/;
        var password = (<string> this.$('.profile-form-password').val());
        var password2 = (<string> this.$('.profile-form-password-2').val());


        var errors = [];
        if (name.length === 0) errors.push('Name may not be empty');
        if (phone && !phone.match(phoneValidator)) errors.push('Phone Number is not valid (must include area code)');

        var updatePassword = this.$('.profile-form-password').is(':visible');
        if (updatePassword) {
            if (password.length === 0) errors.push('Password may not be empty');
            if (password !== password2) errors.push('Passwords do not match');
            if (checkPasswordPolicy(password).fail.length) errors.push('Invalid password');
        }
        if (errors.length) return this.setErrors(errors);

        if (!phone) phone = null;
        if (!company) company = null;
        if (!role) role = null;

        var data = {
            name: name,
            company_name: company,
            company_role: role,
            phone_number: phone,
            timezone: timezone,
        };

        if (updatePassword) {
            data['password'] = password;
        }

        this.collectionLoaded = false;
        this.render();
        $.ajax({
            type: "PUT",
            url: this.options.currentUserProfile.url(),
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: () => {
                if (updatePassword) {
                    window.location.hash = '#logout';
                } else {
                    this.options.currentUser = this.options.userCollection.findWhere({
                        id: Number(this.options.currentUser.get('id'))
                    });
                    window['App'].Bus.trigger('switch:user', this.options.currentUser);
                    this.reloadUrl();
                }

                Intercom.trackEvent('changed-profile');
            }
        });
    }
}

export class UserTeamView extends BaseUserDetailView {

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/users/' +
            this.options.currentUserProfile.get('id') + '/teams';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Teams', url: this.options.isOverview ? url : null},
            panelClass: 'teams',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        this.collectionLoaded = true;
        this.render();
        this.showTable();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
    }

    showTable() {
        var teamTable = new BaseList(this.options);
        var teamTableProperties: TableProperties;
        teamTableProperties = {
            tableEmptyText: (this.options.currentUserProfile.get('id') === this.options.currentUser.get('id') ? 'You are' : 'This User is') + 'not a part of any teams',
            // rowUrl: '#/account/'+this.options.currentOrganizationId+'/teams/',
            columnProperties: {
                'Team Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '4',
                        'md': '4',
                        'xs': '12'
                    }
                },
                'Admin': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-4 col-sm-4 col-xs-10 account-modify-team-admin text-center">' +
                            ' <%- mod.get("is_admin") ? "Yes" : "No" %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '4',
                        'md': '4',
                        'xs': '10'
                    }
                },
                'Member Since': {
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = currentUserProfile.get("usergroups")[mod.get("id")] ? currentUserProfile.get("usergroups")[mod.get("id")]["invitation_accepted_date"] : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-4 col-sm-4 col-xs-10"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-4 col-sm-4 col-xs-10 account-modify-team-member-since">' +
                            ' <div class="account-modify-team-invitation-pending">' +
                            ' Invitation Pending <br>' +
                            ' <a class="clickable account-modify-team-resent-invite team-footer table-link" data-user-id="<%-  currentUserProfile.get("id") %>" data-usergroup-id="<%- mod.get("id") %>">' +
                            ' Resend Invitation' +
                            ' </a>' +
                            ' <span class="text-success account-modify-team-invitation-sent hidden">Sent.</span>' +
                            ' </div>' +
                            ' <div class="modal-form-spinner hidden">' +
                            ' <div class="spinner-rect">' +
                            ' <div class="rect1"></div>' +
                            ' <div class="rect2"></div>' +
                            ' <div class="rect3"></div>' +
                            ' <div class="rect4"></div>' +
                            ' <div class="rect5"></div>' +
                            ' </div>' +
                            ' </div>' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            currentUserProfile: this.options.currentUserProfile,
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '4',
                        'md': '4',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            teamTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'is_admin',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }
        var teams = this.options.userGroupCollection.filter((team) => {
            return _.has(this.options.currentUserProfile.get('usergroups'), String(team.get('id')))
        });
        var userGroupCollection = new UserGroupCollection(teams, {
            organizationId: this.options.currentOrganizationId
        });
        this.$('.teams .panel-body > .row').empty().append(
            teamTable.renderCollectionList(userGroupCollection, teamTableProperties).$el
        );
    }
}

export class UserDashboardView extends BaseUserDetailView {

    private dashboardCollection: DashboardCollection = null;
    private permissionsCollections: { [key: number]: PermissionCollection } = {};
    private dashboardWidgetCollections: { [dashboardId: number]: DashboardWidgetCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/users/' +
            this.options.currentUserProfile.get('id') + '/dashboards';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Dashboards', url: this.options.isOverview ? url : null},
            panelClass: 'dashboards',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds1 = [], deferreds2 = [];
        if (this.options.permissionCollection.canViewOrganization(this.options.currentOrganizationId)) {
            _.each(_.keys(this.options.currentUserProfile.get('usergroups')), (userGroupId) => {
                this.permissionsCollections[userGroupId] = new PermissionCollection([], {userGroupId: Number(userGroupId)});
                deferreds1.push(this.permissionsCollections[userGroupId].fetch());
            });
        }

        $.when.apply($, deferreds1).done(() => {
            var viewableDashboardIds = _.uniq(_.flatMap(this.permissionsCollections, (p: PermissionCollection) => {
                return p.getViewableDashboardIds()
            }));
            var dashboards = this.options.dashboardCollection.filter((dashboard) => {
                return _.includes(viewableDashboardIds, Number(dashboard.get('id')))
                    && dashboard.get('organization_id') === this.options.currentOrganizationId;
            });
            this.dashboardCollection = new DashboardCollection(dashboards);

            this.dashboardCollection.each((dash) => {
                this.dashboardWidgetCollections[dash.get('id')] = new DashboardWidgetCollection([], {dashboardId: dash.get('id')});
                deferreds2.push(this.dashboardWidgetCollections[dash.get('id')].fetch());
            });

            $.when.apply($, deferreds2).done(() => {
                this.collectionLoaded = true;
                this.render();
                this.showTable();
                (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
            });
        });
    }

    showTable() {
        var dashboardTable = new BaseList(this.options);
        var dashboardTableProperties: TableProperties;
        var getDashboardModifiedDate = function (dash, widCols) {
            var dates = [moment(dash.get('modified')).format("L")];

            var widgetDate = 0;
            widCols[dash.get('id')].each((widget) => {
                if (widget.get('modified') > widgetDate) widgetDate = widget.get('modified')
            });

            if (widgetDate !== 0) dates.push(moment.unix(widgetDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();

            return _.first(dates);
        };

        dashboardTableProperties = {
            tableEmptyText: (this.options.currentUserProfile.get('id') === this.options.currentUser.get('id') ? 'You have ' : 'This User has ') + 'no Dashboards',
            columnProperties: {
                'Dashboard Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Installs': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var filteredChannels = dashboardChannelCollection.filter(function(c){ return c.get("dashboard_channel_dashboard_id") === mod.get("id")}); %>' +
                            '<% var dbInstallNames = _.map(' +
                            '_.uniq(' +
                            '_.map(filteredChannels, function(c){' +
                            'return c.get("install_id")' +
                            '})), function(installId){' +
                            'if(permissionCollection.canViewInstall(installId)){' +
                            'return _.find(installCollection.models, function(i){return i.get("id") === installId}).getDisplayName()' +
                            '}' +
                            '}); %>' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10" data-table-cell="<%- dbInstallNames.sort().join(", ") %>">' +
                            '<%- _.compact(dbInstallNames).sort().join(", ") %>' +
                            ' </div>'),
                        variables: {
                            dashboardChannelCollection: this.options.dashboardChannelCollection,
                            permissionCollection: this.options.permissionCollection,
                            installCollection: this.options.installCollection
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center" data-table-cell="<%- moment(inviteDate).format("L") %>"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center">' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('' +
                            '<% var inviteDate = getDashboardModifiedDate(mod, widCols) %> ' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10 text-center"><%- inviteDate ? inviteDate : "" %></div>'),
                        variables: {
                            moment: moment,
                            widCols: this.dashboardWidgetCollections,
                            getDashboardModifiedDate: getDashboardModifiedDate
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            dashboardTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        this.$('.dashboards .panel-body > .row').empty().append(
            dashboardTable.renderCollectionList(this.dashboardCollection, dashboardTableProperties).$el
        );
    }
}

export class UserInstallView extends BaseUserDetailView {

    private permissionsCollections: { [key: number]: PermissionCollection } = {};

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/users/' +
            this.options.currentUserProfile.get('id') + '/installs';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.html(this.template({
            panelTitle: {text: 'Installations', url: this.options.isOverview ? url : null},
            panelClass: 'installs',
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        return this;
    }

    show() {
        var deferreds = [];
        if (this.options.permissionCollection.canViewOrganization(this.options.currentOrganizationId)) {
            _.each(_.keys(this.options.currentUserProfile.get('usergroups')), (userGroupId) => {
                this.permissionsCollections[userGroupId] = new PermissionCollection([], {userGroupId: Number(userGroupId)});
                deferreds.push(this.permissionsCollections[userGroupId].fetch());
            });
        }

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        })
    }

    showTable() {
        var installTable = new BaseList(this.options);
        var installTableProperties: TableProperties;
        installTableProperties = {
            tableEmptyText: (this.options.currentUserProfile.get('id') === this.options.currentUser.get('id') ? 'You have ' : 'This User has ') + 'no Installations',
            columnProperties: {
                'Install Name': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-3 col-sm-3 col-xs-10" data-table-cell="<%- mod.getDisplayName() %>">' +
                            ' <%- mod.getDisplayName() %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Address': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-2 col-sm-2 col-xs-10" data-table-cell="<%- mod.getDisplayAddress() ? mod.getDisplayAddress() : "" %>">' +
                            ' <%- mod.getDisplayAddress() ? mod.getDisplayAddress() : "" %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Gateway Serial Number': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center" data-table-cell="<%- moment(inviteDate).format("L") %>"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("modified") ? mod.get("modified") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center" data-table-cell="<%- moment(inviteDate).format("L") %>"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center">' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };

        if (this.options.isOverview) {
            installTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var viewableInstallIds = _.uniq(_.flatMap(this.permissionsCollections, (p: PermissionCollection) => {
            return p.getViewableInstallIds()
        }));
        var installs = this.options.installCollection.filter((install) => {
            return _.includes(viewableInstallIds, Number(install.get('id')))
                && install.get('organization_id') === this.options.currentOrganizationId;
        });
        var installCollection = new InstallCollection(installs);
        this.$('.installs .panel-body > .row').empty().append(
            installTable.renderCollectionList(installCollection, installTableProperties).$el
        );
    }
}

export class UserNotificationView extends BaseUserDetailView {

    private dashboardNotificationCollections ?: { [groupId: number]: DashboardNotificationCollection } = {};
    private statusNotificationCollections   ?: { [groupId: number]: StatusNotificationCollection } = {};

    render() {
        this.$el.empty();
        if (this.options.isOverview) {
            this.appendPanel('Notifications', 'notifications')
        } else {
            this.appendPanel('Dashboard Notifications', 'dashboard-notifications');
            this.appendPanel('Installation Notifications', 'install-notifications');
        }
        return this;
    }

    private appendPanel(title: string, klass: string) {
        var url = '/#/account/' + this.options.currentOrganizationId + '/users/' +
            this.options.currentUserProfile.get('id') + '/notifications';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.append(this.template({
            panelTitle: {text: title, url: this.options.isOverview ? url : null},
            panelClass: klass,
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
    }

    show() {
        var deferreds = [];

        // Load notifications for all groups that the user is part of
        var userGroupIds = _.map(_.keys(this.options.currentUserProfile.get('usergroups')), Number);
        _.each(userGroupIds, (g) => {
            this.dashboardNotificationCollections[g] = new DashboardNotificationCollection([], {userGroupId: g});
            this.statusNotificationCollections[g] = new StatusNotificationCollection([], {userGroupId: g});

            deferreds.push(
                this.dashboardNotificationCollections[g].fetch(),
                this.statusNotificationCollections[g].fetch()
            );
        });

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();
            this.showTable();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        })
    }

    showTable() {
        var tableWidth = this.options.isOverview ? 'col-md-6 col-sm-6 col-xs-12' : 'col-md-12 col-sm-12 col-xs-12';

        var notificationDashboardTable = new BaseList(this.options);
        var notificationDashboardTableProperties: TableProperties = {
            tableEmptyText: (this.options.currentUserProfile.get('id') === this.options.currentUser.get('id') ? 'You have ' : 'This User has ') + '0 Dashboard Notifications',
            columnProperties: {
                'Dashboard': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '12'
                    }
                },
                'Enabled Notifications': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var enabledNotifications = [] %>' +
                            '<% _.each(dashboardNotificationCollections, function(col) { %>' +
                            '<% var dashboardNotification = col.findWhere({dashboard_id: mod.get("id")}); %>' +
                            '<% dashboardNotification && dashboardNotification.get("enable_email_notifications") && dashboardNotification.get("dashboard_channels").length ? enabledNotifications.push("Email") : "" %>' +
                            '<% dashboardNotification && dashboardNotification.get("enable_sms_notifications") && dashboardNotification.get("dashboard_channels").length ? enabledNotifications.push("Text") : "" %>' +
                            '<% }); %>' +
                            '<% if(enabledNotifications.length) { %>' +
                            '<div class="col-md-6 col-sm-6 col-xs-10" data-table-cell="<%- _.uniq(enabledNotifications).sort().join(", ") %>">' +
                            '<%- _.uniq(enabledNotifications).sort().join(", ") %>' +
                            '</div>' +
                            '<% } else { %>' +
                            '<div class="col-md-6 col-sm-6 col-xs-10"></div>' +
                            '<% } %>'),
                        variables: {
                            dashboardNotificationCollections: this.dashboardNotificationCollections,
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '12'
                    }
                }
            },
            tableWidth: tableWidth
        };

        var notificationInstallTable = new BaseList(this.options);
        var notificationInstallTableProperties: TableProperties;
        notificationInstallTableProperties = {
            tableEmptyText: (this.options.currentUserProfile.get('id') === this.options.currentUser.get('id') ? 'You have ' : 'This User has ') + '0 Installation Notifications',
            columnProperties: {
                'Installation': {
                    customColumn: {
                        templateFunction: _.template(' <div class="col-md-6 col-sm-6 col-xs-10">' +
                            ' <%- mod.getDisplayName() %>' +
                            ' </div>')
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '12'
                    }
                },
                'Enabled Notifications': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var enabledNotifications = [] %>' +
                            '<% _.each(statusNotificationCollections, function(col) { %>' +
                            '<% var statusNotification = col.findWhere({install_id: mod.get("id")}); %>' +
                            '<% statusNotification && statusNotification.get("enable_email_notifications") ? enabledNotifications.push("Email") : "" %>' +
                            '<% statusNotification && statusNotification.get("enable_sms_notifications") ? enabledNotifications.push("Text") : "" %>' +
                            '<% }); %>' +
                            '<% if(enabledNotifications.length) { %>' +
                            '<div class="col-md-6 col-sm-6 col-xs-10" data-table-cell="<%- _.uniq(enabledNotifications).sort().join(", ") %>">' +
                            '<%- _.uniq(enabledNotifications).sort().join(", ") %>' +
                            '</div>' +
                            '<% } else { %>' +
                            '<div class="col-md-6 col-sm-6 col-xs-10"></div>' +
                            '<% } %>'),
                        variables: {
                            statusNotificationCollections: this.statusNotificationCollections,
                        }
                    },
                    columnSizes: {
                        'sm': '6',
                        'md': '6',
                        'xs': '12'
                    }
                }
            },
            tableWidth: tableWidth
        };

        var installs = this.options.installCollection.filter((install) => {
            var hasNotif = false;
            _.each(this.statusNotificationCollections, (statusCol: StatusNotificationCollection) => {
                var statusNot = statusCol.findWhere({install_id: install.get("id")});
                if (!statusNot) return;
                if (statusNot.get("enable_email_notifications") || statusNot.get("enable_sms_notifications")) hasNotif = true
            });

            return _.includes(this.options.permissionCollection.getViewableInstallIds(), Number(install.get('id')))
                && install.get('organization_id') === this.options.currentOrganizationId
                && hasNotif;
        });
        var installCollection = new InstallCollection(installs);

        var dashboards = this.options.dashboardCollection.filter((dashboard) => {
            var hasNotif = false;
            _.each(this.dashboardNotificationCollections, (statusCol: StatusNotificationCollection) => {
                var dashNot = statusCol.findWhere({dashboard_id: dashboard.get("id")});
                if (!dashNot) return;

                if ((dashNot.get("enable_email_notifications") || dashNot.get("enable_sms_notifications")) && dashNot.get("dashboard_channels").length) {
                    hasNotif = true
                }
            });
            return _.includes(this.options.permissionCollection.getViewableDashboardIds(), Number(dashboard.get('id')))
                && dashboard.get('organization_id') === this.options.currentOrganizationId
                && hasNotif;
        });
        var dashboardCollection = new DashboardCollection(dashboards);

        var dashboardNotificationContainer, installNotificationContainer;
        if (this.options.isOverview) {
            dashboardNotificationContainer = installNotificationContainer = this.$('.notifications .panel-body > .row');
            notificationDashboardTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'enable_email_notifications',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
            notificationDashboardTableProperties['name'] = 'Dashboard Notifications';

            notificationInstallTableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'organization_install_name',
                reverseSort: false,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
            notificationInstallTableProperties['name'] = 'Installation Notifications'

        } else {
            dashboardNotificationContainer = this.$('.dashboard-notifications .panel-body > .row');
            installNotificationContainer = this.$('.install-notifications .panel-body > .row');
        }

        dashboardNotificationContainer.append(
            notificationDashboardTable.renderCollectionList(dashboardCollection, notificationDashboardTableProperties).$el
        );
        installNotificationContainer.append(
            notificationInstallTable.renderCollectionList(installCollection, notificationInstallTableProperties).$el
        );
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/user/UserDetailViews.ts